var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMic = function SvgMic(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M12 1.5A4.5 4.5 0 0 0 7.5 6v6a4.5 4.5 0 1 0 9 0V6A4.5 4.5 0 0 0 12 1.5M15 12V6a3 3 0 1 0-6 0v6a3 3 0 1 0 6 0",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.25 19.463A7.5 7.5 0 0 1 4.5 12v-1.5a.75.75 0 0 1 1.5 0V12a6 6 0 0 0 12 0v-1.5a.75.75 0 0 1 1.5 0V12a7.5 7.5 0 0 1-6.75 7.463v2.287a.75.75 0 0 1-1.5 0z"
  })));
};
export default SvgMic;